// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2o975","toggle":"styles_toggle__2PaBg","preview":"styles_preview__2wbk_"};